import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// First, so default date ranges are worked out in the agency's time zone.
import './zoneBoot';
import { App } from './App';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
